import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {updateSingleConversationLogs} from './chatbotAPI'

const initialState = {
    live_users: {},
    liveChat_selectedUser: null,
    pastChatWindow_selectedUser:null,
    notifications: [],
    pastChatWindow_messageLogs: [],
    admin_info: {
        socket_id: null,
    }
}

const getDBCollectionName = (state, userSocketId) => {
    let { live_users, admin_info } = state
    let tempUser = live_users[userSocketId]['userInfo']['cf_display_username']
    let collectionName = `${admin_info.cf_socket_username}__JOIN__${tempUser}`
    return collectionName    
}

const chatbotSlice = createSlice({
    name: 'chatbot',
    initialState,
    reducers: {
        update_admin_info: (state, action) => {
            state.admin_info = {
                ...state.admin_info,
                ...action.payload
            }
            console.log(state.admin_info)
        },
        
        add_notification: (state, action) => {
            state.notifications = [...state.notifications, action.payload];
        },
        clear_all_notification: (state, action) => {
            state.notifications = []
        },
        add_new_live_user: (state, action) => {
            const { userId, userInfo, timestamp } = action.payload
            state.live_users[userId] = {
                userInfo: {
                    ...userInfo,
                    timestamp: timestamp ,
                    socket_id: userId,
                }
            }
    
            let newUser_notification = { timestamp, msgText: "New User Joined Conversation", type: 'newUser' }
            state.notifications = [...state.notifications, newUser_notification];

        },
        update_liveChat_selectedUser: (state, action) => {
            state.pastChatWindow_selectedUser = null;
            state.liveChat_selectedUser = action.payload
        },
        update_pastChatWindow_selectedUser: (state, action) => {
            state.liveChat_selectedUser = null;
            state.pastChatWindow_selectedUser = action.payload;
        },
        set_pastChatWindow_messageLogs: (state, action) => {
            state.pastChatWindow_messageLogs = action.payload
        },
        update_liveChat_selectedUser_MessageLogs: (state, action) => {
            const { from, data } = action.payload
            let user_role = 'admin'

            const msg_info_list = data[0]?.split("_CFMSG_");
            
            if (msg_info_list.length <= 1) return;
            let [socket_id, user_referrer, msgText,severMsgUser] = msg_info_list;

            if (from === 'serverMsg') {
                user_role = severMsgUser
            }
            if(from==='admin') msgText =user_referrer
            if ('chat_logs' in state.live_users[socket_id]) {
                console.log("repeat :",data[1])
                
                state.live_users[socket_id]['chat_logs'] = [
                    ...state.live_users[socket_id]['chat_logs'],
                    data[1]
                    ]

            } else {
    
                state.live_users[socket_id] = {
                    ...state.live_users[socket_id],
                    chat_logs: [
                        data[1]
                      ]
                }


            }
        },
        update_liveChat_selectedUser_previousMessageLogs: (state,action) =>{
            const {data } = action.payload;
            const socket_id = data[0].socket_id1[0]
    
            data.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
            
            state.live_users[socket_id] = {
                ...state.live_users[socket_id],
                chat_logs: data
            }

        },
        resetChatBot: (state,action) => {
            return { ...initialState };
        }
    }
})

export const { resetChatBot,update_admin_info,add_cfSocketUsername, add_notification, clear_all_notification, add_new_live_user, update_liveChat_selectedUser, update_pastChatWindow_selectedUser, set_pastChatWindow_messageLogs,update_liveChat_selectedUser_MessageLogs,update_liveChat_selectedUser_previousMessageLogs } = chatbotSlice.actions

export const SelectNotification = (state) => state.chatbot.notifications
export const SelectLiveUsers = (state) => state.chatbot.live_users
export const SelectPastChatWindowMessageLogs = (state) => state.chatbot.pastChatWindow_messageLogs
export const SelectLiveChat_selectedUser = (state) => state.chatbot.liveChat_selectedUser;
export const SelectPastChatWindow_selectedUser = (state) => state.chatbot.pastChatWindow_selectedUser;
export const SelectChatbotLiveUser = (state) => state.chatbot.live_users
export const cfSocketUsername = (state) => state.chatbot.admin_info.cf_socket_username
;

export default chatbotSlice.reducer;
